import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { t } = useTranslation();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", org_name: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      navigate("/dashboard");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("auth.signUpTitle")}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div className="space-y-2">
          <Label>{t("auth.name")}</Label>
          <Input value={form.name} onChange={set("name")} required className="rounded-sm h-11" data-testid="register-name-input" />
        </div>
        <div className="space-y-2">
          <Label>{t("auth.email")}</Label>
          <Input type="email" value={form.email} onChange={set("email")} required className="rounded-sm h-11" data-testid="register-email-input" />
        </div>
        <div className="space-y-2">
          <Label>{t("auth.password")}</Label>
          <Input type="password" value={form.password} onChange={set("password")} required minLength={6} className="rounded-sm h-11" data-testid="register-password-input" />
        </div>
        <div className="space-y-2">
          <Label>{t("auth.orgName")}</Label>
          <Input value={form.org_name} onChange={set("org_name")} placeholder={t("auth.orgNameHint")} className="rounded-sm h-11" data-testid="register-org-input" />
        </div>
        {error && <p className="text-sm text-destructive" data-testid="register-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full rounded-sm h-11" data-testid="register-submit-button">
          {loading ? t("common.loading") : t("auth.signUp")} <ArrowRight size={16} className="ml-1" />
        </Button>
      </form>
      <p className="text-sm text-muted-foreground mt-6">
        {t("auth.haveAccount")}{" "}
        <Link to="/login" className="text-primary font-medium hover:underline" data-testid="goto-login">
          {t("auth.signIn")}
        </Link>
      </p>
    </AuthShell>
  );
}
